module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Zulu.html",
      "xml:lang": "en-GB",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "dedication"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "section",
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART ONE")]), _c('br'), _vm._v("\n      THE HOT HAND")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 72
// module chunks = 0